import { FC } from "react";
import { Tooltip, ITooltipProps, ITooltipContent } from "component-library";

export interface JoiningFormTooltipProps {
  tooltipProps: ITooltipProps;
}

export const getTootlipProps = (
  tooltipHeader: ITooltipContent["header"],
  tooltipBody: ITooltipContent["content"],
  isRichText = false
): ITooltipProps => ({
  texts: {
    header: tooltipHeader,
    content: tooltipBody,
    closeButton: "Close tooltip",
    tooltipName: "Open tooltip",
  },
  config: {
    minimalTopDistance: 50,
    isRichText,
  },
});

const JoiningFormTooltip: FC<JoiningFormTooltipProps> = ({ tooltipProps }) => (
  <div className="flex flex-row-reverse z-1000">
    <div className="w-5 h-5">
      <Tooltip {...tooltipProps}>
        <div className="w-5 h-5 text-lg leading-5 text-center text-white cursor-pointer bg-color-brand-one rounded-3xl">
          ?
        </div>
      </Tooltip>
    </div>
  </div>
);

export default JoiningFormTooltip;
